/**
 * @flow
 * @author: Anesh Parvatha
 */
const images = {
  layers: {
    desktopLayer:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/arcades/arcade-landing-desktop-overlay.svg',
    mobileLayer:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/arcades/arcade-landing-desktop-overlay.svg',
    tabletLayer:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/arcades/arcade-landing-desktop-overlay.svg'
  },
  homePageLayers: {
    desktopLayer:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/iBC_Desktop_Layer.svg',
    mobileLayer:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/iBC_Stadium_layer.svg',
    tabletLayer:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/iBC_stadium_layer_ipad.svg'
  },

  playInInternationalStadium: {
    stripSection:
      'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_1.0,f_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/InternationalStadiumStrip/background.webp'
  },
  officeSectionDesktopOffice360Image:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice360image.webp',
  officeSectionDesktopOffice1:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice1.webp',
  officeSectionDesktopOffice2:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice2.webp',
  officeSectionDesktopOffice3:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice3.webp',
  officeSectionDesktopOffice4:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice4.webp',
  officeSectionDesktopOffice5:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice5.webp',
  officeSectionMobileOffice360Image:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice360image.webp',
  officeSectionMobileOffice1:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice1.webp',
  officeSectionMobileOffice2:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice2.webp',
  officeSectionMobileOffice3:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice3.webp',
  officeSectionMobileOffice4:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice4.webp',
  officeSectionMobileOffice5:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice5.webp',
  officeSectionIpadOffice360Image:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice360image.webp',
  officeSectionIpadOffice1:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice1.webp',
  officeSectionIpadOffice2:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice2.webp',
  officeSectionIpadOffice3:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice3.webp',
  officeSectionIpadOffice4:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice4.webp',
  officeSectionIpadOffice5:
    'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice5.webp',
  mapSectionDesktopMapImage:
    'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Amanora-Mall-Map-desktop.webp',
  mapSectionMobileMapImage:
    'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Amanora-Mall-Map-Mobile.webp',
  mapSectionIpadMapImage:
    'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Amanora-Mall-Map-ipad.webp',
  bookingResponseMapImage:
    'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/map-success-popup%403x.webp',

  testimonials: {
    galleryDesktopKidPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/kids-with-ib-cricket.webp',
    galleryDesktopVIdeoThumbnailKarthikeya:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/actor-karthikeya-crazy-experience-with-ib-cricket.webp',
    galleryDesktopRamNathKovind:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/president-plays-cricket.webp',
    galleryDesktopSeniorsWithOurTeam:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/families-in-ib-cricket-arcade.webp',
    galleryDesktopIBCricket:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/worlds-most-immersive-virtual-reality-cricket.webp',
    galleryDesktopYouthPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/Playing-iBCricket.jpeg',
    galleryDesktopManPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/youngsters-play-iB-Cricket.webp',
    galleryDesktopWomenExperiencingIbc:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/everyone-plays-vr-cricket.webp',
    galleryDesktopTestimonialQuote:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryDesktopTestimonialQuote.png',
    galleryMobileKidPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileKidPlaying.webp',
    galleryMobileVIdeoThumbnailKarthikeya:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/actor-karthikeya-crazy-experience-with-ib-cricket.webp',
    galleryMobileRamNathKovind:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileRamNathKovind.webp',
    galleryMobileSeniorsWithOurTeam:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileSeniorsWithOurTeam.webp',
    galleryMobileIBCricket:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/worlds-most-immersive-virtual-reality-cricket.webp',
    galleryMobileYouthPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/Playing-iBCricket.jpeg',
    galleryMobileManPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileManPlaying.webp',
    galleryMobileWomenExperiencingIbc:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileWomenExperiencingIbc.webp',
    galleryIpadKidPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadKidPlaying.webp',
    galleryIpadVIdeoThumbnailKarthikeya:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/ipad/actor-karthikeya-crazy-experience-with-ib-cricket.webp',
    galleryIpadRamNathKovind:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadRamNathKovind.webp',
    galleryIpadSeniorsWithOurTeam:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadSeniorsWithOurTeam.webp',
    galleryIpadIBCricket:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/ipad/worlds-most-immersive-virtual-reality-cricket.webp',
    galleryIpadYouthPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/Playing-iBCricket.jpeg',
    galleryIpadManPlaying:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadManPlaying.webp',
    galleryIpadWomenExperiencingIbc:
      'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/ipad/woman-experiencing-ib-cricket.png'
  }
}

export default images



// WEBPACK FOOTER //
// ./src/themes/Images.js